
export default {
  email: 'Email',
  name: 'Name',
  picture: 'Picture',
  preservedBy: 'Preserved by',
  poweredBy: 'Powered by',
  attachments: 'Files',
  conjunctions: {
    and: 'and',
  },
  messages: {
    errors: {
      couponExpired: 'This coupon has expired or it has already been used.',
    },
    enterprise: {
      areaZoom: 'Compensation',
      maxZoom: 'Choose your m2',
      minZoom: 'The World',
    },
    map: {
      areaZoom: 'Park',
      maxZoom: 'Choose your PIC',
      minZoom: 'The World',
    },
    mobile: {
      coupon: 'Gift Coupon',
      payment: 'Random Pic',
    },
    mobileRedeem: {
      congratsMessage: "Now you're officialy a PIC preserver in %{project}.%{breakline}Thank you for your support!",
      congratsTitle: 'Welcome %{name}!',
      header: 'Redeem a Coupon',
      plotsInputUnit: 'lot unlocked | lots unlocked',
      shareOnFacebook: 'Share on Facebook',
      subtitle: 'With an annual membership you will help preserve one of our projects.',
      title: 'You are awesome!',
      placeholders: {
        couponCode: 'Type your code here',
        plots: 'Your PIC lots',
        selectProject: 'Select Project',
      },
      errors: {
        default: 'There has been a problem, please try again.',
        plotNotFound: "We couldn't find a place in this project, please try again.",
      },
    },
    paymentSelector: {
      balance: 'Your balance is $%{amount} USD',
      coupon: 'Gift coupon',
      placeholders: {
        couponCode: 'Escribe tu código acá',
      },
      errors: {
        belongsOtherProjects: 'This coupon belongs to %{projects} project. | This coupon belongs to %{projects} projects.',
      },
    },
    picConfirm: {
      title: 'Buy %{count} PIC | Buy %{count} PICS',
    },
    photoUploader: {
      missing: 'Upload your best photo.',
    },
    purchaseSidebar: {
      balance: 'Your balance is $%{amount} %{currency}',
      benefits: "You're paying %{amount} for an annual support at %{project}.",
      buyBtn: 'Buy %{amount} pic! | Buy %{amount} pics!',
      congratsMessage: "Now you're officialy a PIC preserver in %{project}.{breakline}Thank you for your support!",
      congratsTitle: '%{name}, you are awesome!',
      continuePreserving: 'Continue Preserving',
      coupon: 'Gift coupon',
      nextStepTitle: 'What now?',
      personalInfo: 'Personal Info.',
      shareWithWorld: 'Share it with the world',
      shoppingSubtitle: 'Buy %{count} PIC at %{project} | Buy %{count} PICS at %{project}',
      terms: 'terms and conditions',
      title: 'Buy a PIC. Support your planet',
      disclaimers: {
        acceptTerms: '%{icon} I accept the %{link} of PIC.',
        age: "I'm at least 16 years old.",
      },
      errors: {
        belongsOtherProjects: 'This coupon belongs to %{projects} project. | This coupon belongs to %{projects} projects.',
        email: 'Please enter a valid email.',
        name: 'Please enter a valid name',
        invalidCouponCurrency: 'This coupon is only valid for projects that use %{currency}.',
      },
    },
    sidebar: {
      picparks: 'PICparks Projects',
      haveJoined: 'have joined.',
      humidity: 'Humidity',
      morePeople: '%{count} more person | %{count} more people',
      picsLeft: '%{count} PIC left | %{count} PICS left',
      preservedPercentage: '%{percentage}% PRESERVED',
      zoomProjectBtn: 'Pic this project!',
      createAlarmButton: 'Create Alarm',
      destroyAlarmButton: 'Remove Alarm',
    },
  },
};
